var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"overlay"},[_c('button',{staticClass:"overlay__close",on:{"click":_vm.close}},[_c('img',{attrs:{"src":require("@/assets/close.png"),"alt":"close"}})]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }